import { BrowserWindow } from '@wix/thunderbolt-symbols'
import { CssOverrides } from '@wix/thunderbolt-commons'

const meshRuntimeClass = 'with-runtime-mesh'

export const getRuntimeMeshOverridesManager = () => {
	const meshStyleTagId = 'MESH_RUNTIME_OVERRIDES'
	let stylesForSelector: { [compId: string]: CssOverrides } = {}

	const updateStyleOverrides = (window: NonNullable<BrowserWindow>): void => {
		window.document.getElementById(meshStyleTagId)!.innerHTML = Object.keys(stylesForSelector)
			.map((selector) => {
				const stylesMap = stylesForSelector[selector]
				const cssString = Object.keys(stylesMap)
					.map((key) => `${key}: ${stylesMap[key]};`)
					.join('\n')

				return `.${meshRuntimeClass} ${selector} {${cssString}}`
			})
			.join('\n')
	}

	const isEmpty = () => Object.keys(stylesForSelector).length === 0

	return {
		setItemCssOverrides: (cssOverrides: CssOverrides, selector: string, window: NonNullable<BrowserWindow>) => {
			if (!window.document.getElementById(meshStyleTagId)) {
				const style = document.createElement('style')
				style.id = meshStyleTagId
				document.body.appendChild(style)
			}

			stylesForSelector[selector] = cssOverrides
			updateStyleOverrides(window)
		},
		clearAllItemsCssOverrides: (window: NonNullable<BrowserWindow>) => {
			if (!isEmpty()) {
				stylesForSelector = {}
				updateStyleOverrides(window)
			}
		},
	}
}
